import React, { Fragment } from "react";
import {
    Button,
    CircularProgress,
    colors,
    Container,
    FormControlLabel,
    Grid,
    Paper,
    TextField,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import {
    useStylesUp, useStylesHed, useStylesAuto, useStylesTF, useStylesTD, useStylesBA, useStylesLbl
    , useStylesUiElemment,
    useStylesSpDial
} from '../../../../St/Reports/UseStyle';
import InvoiceOilPayFilter from "./InvoiceOilPayFilter";
import { Autocomplete } from "@material-ui/lab";
import { Print } from "@material-ui/icons";
import { SaleCheckbox, useStylesCAB } from "../../../../St/comps/UseStyle";
export default function InvoiceOilPay(props) {
    const {
        fromQountity,
        setfromQountity,
        selectOilTypePay,
        subInfo,
        changSwitch,
        valueStock,
        AutoOptions,
        changAutoStock,
        changAutoBank,
        toPrint,
        valueBank,
        itemName,
        loading,
        idata,
        valuePumps,
        showPaid,
        setShowPaid,
    } = props;
    const clasAo = useStylesAuto();
    const clasTF = useStylesTF();
    const claslbl = useStylesLbl();
    const claslbls = useStylesLbl();

    const clasCAB = useStylesCAB();

    const { t } = useTranslation(["forms", "translation"]);

    return (
        <React.Fragment>
            <Grid container style={{ padding: 5 }} spacing={1}>
                <Container
                    component={Paper}
                    maxWidth={false}
                    style={{
                        padding: "10px",
                        paddingBottom: "0px",
                        borderBottomColor: colors.green[300],
                        borderBottomWidth: "1px",
                        borderBottomStyle: "solid",
                    }}
                >

                    <InvoiceOilPayFilter {...{
                        fromQountity,
                        setfromQountity,
                        selectOilTypePay,
                        changSwitch,
                        idata
                    }} />

                    <Grid item lg={1} md={1} sm={2} xs={12} style={{ paddingBottom: "0.5rem" }}>
                        <FormControlLabel
                            id="showPaid"
                            value="showPaid"
                            name="showPaid"
                            className={claslbl.clor}
                            control={
                                <SaleCheckbox
                                    checked={showPaid}
                                    onChange={(e) => {
                                        setShowPaid(e.target.checked);
                                    }}
                                    color={ "primary"}
                                />
                            }
                            label={t("paid_screen")}
                            labelPlacement="end"
                        />
                    </Grid>
                    <Fragment>
                        <Grid item container justifyContent="center" xs={12} spacing={1}>
                            {AutoOptions?.permType?.id === 4 &&
                                (
                                    <Grid item lg={6} md={6} sm={12} xs={12} style={{ paddingBottom: "1rem" }}>
                                        <TextField fullWidth
                                            variant="outlined"
                                            size="small"
                                            id="symbol"
                                            label={"اسم المضخة"}
                                            className={clasTF.rootSale}
                                            InputProps={{ className: claslbl.clrSaleOil, readOnly: true }}
                                            InputLabelProps={{ className: claslbl.clrSaleLabelOil }}
                                            type="text"
                                            name="pump"
                                            value={valuePumps?.name}
                                        />
                                    </Grid>
                                )}


                            <Grid item lg={6} md={6} sm={12} xs={12} style={{ paddingBottom: "1rem" }}>
                                <TextField fullWidth
                                    variant="outlined"
                                    size="small"
                                    id="symbol"
                                    label={t("item-name")}
                                    className={clasTF.rootSale}
                                    InputProps={{ className: claslbl.clrSale, readOnly: true }}
                                    InputLabelProps={{ className: claslbl.clrSale }}
                                    type="text"
                                    name="symbol"
                                    value={itemName ?? ""}
                                /></Grid>
                            <Grid item lg={6} md={6} sm={12} xs={12} style={{ paddingBottom: "1rem" }}>
                                <TextField fullWidth
                                    variant="outlined"
                                    size="small"
                                    id="symbol"
                                    label={t("total")}
                                    className={clasTF.rootSale}
                                    InputProps={{ className: claslbl.clrSale, readOnly: true }}
                                    InputLabelProps={{ className: claslbl.clrSale }}
                                    type="number"
                                    name="symbol"
                                    value={idata?.netAmount}
                                /></Grid>
                            {fromQountity?.pay?.id == 1 &&
                                <Grid item lg={6} md={6} sm={6} xs={12} style={{ paddingBottom: "1rem" }}>
                                    <Autocomplete
                                        classes={clasAo}
                                        value={valueStock}
                                        onChange={(event, newValue) => {
                                            changAutoStock(newValue);
                                        }}
                                        id="controllable-states-demo"
                                        size="small"
                                        options={AutoOptions.Stocks}
                                        getOptionLabel={(option) =>
                                            typeof option === "string" ? option : option.name
                                        }
                                        disableClearable
                                        renderInput={(params) => (
                                            <TextField
                                                id="bank"
                                                {...params}
                                                label={t("account")}
                                                variant="outlined"
                                                size="small"
                                                InputLabelProps={{ className: claslbls.clrBlackLblSal }}
                                            />
                                        )}
                                    />

                                </Grid>

                            }
                            {fromQountity?.pay?.id == 2 &&
                                <Grid item lg={6} md={6} sm={6} xs={12} style={{ paddingBottom: "1rem" }}>
                                    <Autocomplete
                                        classes={clasAo}
                                        value={valueBank}
                                        onChange={(event, newValue) => {
                                            changAutoBank(newValue);
                                        }}
                                        id="controllable-states-demo"
                                        size="small"
                                        options={AutoOptions.Banks}
                                        getOptionLabel={(option) =>
                                            typeof option === "string" ? option : option.name
                                        }
                                        disableClearable
                                        renderInput={(params) => (
                                            <TextField
                                                id="bank"
                                                {...params}
                                                label={"الحساب"}
                                                variant="outlined"
                                                size="small"
                                                InputLabelProps={{ className: claslbls.clrBlackLblSal }}
                                            />
                                        )}
                                    />

                                </Grid>

                            }

                            <br />
                            <br />
                            <br />
                            <br />

                            <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Button
                                    fullWidth
                                    autoFocus
                                    variant="contained"
                                    color="primary"
                                    onClick={() => toPrint("print", "e", 1)}
                                    style={{
                                        background: colors.green[500],
                                        ...{
                                            paddingLeft: 0,
                                            paddingRight: 0,
                                        },
                                    }}
                                    startIcon={<Print />}
                                >
                                    {" "}
                                    {"  .    دفع    ."}
                                    {(loading.print || loading.save) && (
                                        <CircularProgress
                                            size={24}
                                            className={clasCAB.buttonProgressCAB}
                                        />
                                    )}
                                </Button>
                            </Grid>

                        </Grid>

                    </Fragment>


                </Container>


            </Grid>
        </React.Fragment>
    );
}
